// extracted by mini-css-extract-plugin
module.exports = {"messageRightRoot":"Message_messageRightRoot__ysXNT","messageBody":"Message_messageBody__nIvHz"};